import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { BookingFormPage } from './pages/booking/BookingFormPage';
import { BookingEstimatePage } from './pages/booking/BookingEstimatePage';
import { BookingDepositPage } from './pages/booking/BookingDepositPage';
import { BookingConfirmationPage } from './pages/booking/BookingConfirmationPage';
import { PortalPage } from './pages/portal/PortalPage';
import './styles/globals.css';

function BookingNotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-mist px-4">
      <div className="bg-white rounded-lg shadow-brand-md p-8 text-center max-w-sm">
        <h1 className="text-xl font-semibold text-midnight mb-2">Page Not Found</h1>
        <p className="text-slate text-body">
          The booking page you&apos;re looking for doesn&apos;t exist.
        </p>
      </div>
    </div>
  );
}

function BookingApp() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <Routes>
          <Route path="/portal/:token" element={<PortalPage />} />
          <Route path="/:slug" element={<BookingFormPage />} />
          <Route path="/:slug/estimate" element={<BookingEstimatePage />} />
          <Route path="/:slug/deposit" element={<BookingDepositPage />} />
          <Route path="/:slug/confirmation" element={<BookingConfirmationPage />} />
          <Route path="*" element={<BookingNotFoundPage />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BookingApp />
  </React.StrictMode>,
);
